import React from 'react';
import { XCircle } from 'lucide-react';

/**
 * Banner ditampilkan ketika router MikroTik terdeteksi offline.
 * Menggantikan section data live yang stale agar info tidak menyesatkan.
 */
export const MPanelOfflineBanner = ({ visible }) => {
  if (!visible) return null;
  return (
    <div
      data-testid="mpanel-offline-banner"
      className="bg-red-50 dark:bg-red-900/20 border-2 border-red-200 dark:border-red-800 rounded-lg p-6 text-center"
    >
      <XCircle className="w-12 h-12 text-red-500 mx-auto mb-3" />
      <h3 className="text-lg font-semibold text-red-700 dark:text-red-400 mb-1">
        Router Sedang Offline
      </h3>
      <p className="text-sm text-red-600 dark:text-red-300">
        Tidak dapat mengambil data live dari router. Data lama disembunyikan
        untuk mencegah informasi yang menyesatkan.
      </p>
      <p className="text-xs text-red-500 dark:text-red-400 mt-2">
        Pastikan router online dan API service aktif, lalu klik Refresh Data.
      </p>
    </div>
  );
};
